import React from "react";
import {
  Container,
  Header,
  Profile,
  ProfileName,
  Actions,
  Button,
  ButtonText,
  Stats,
  Stat,
  StatText,
  Divider,
} from "./styles";
import TextView from "../TextView";
import UserImage from "../UserImage";
import useScreenSize from "../../hooks/useScreenSize";
import { useNavigate } from "react-router-dom";
import { CircularProgress } from "@mui/material";
import { colors } from "../../utils";

function AuthorInfo({
  data = {},
  handleFollow = () => {},
  followLoading,
  isFollowing,
  isUserProfile,
  followerCount,
}) {
  const safeData = data || {};
  const {
    first_name,
    last_name,
    profile_image,
    user_id,
    username,
    number_of_wheels,
    followers,
    followings,
  } = safeData;
  const { isMobileLandscape } = useScreenSize();
  const navigate = useNavigate();

  const handleProfileClick = () => {
    if (user_id) {
      navigate(`/gallery/${user_id}`);
    }
  };

  return (
    <Container>
      <Header>
        <Profile onClick={handleProfileClick} style={{ cursor: "pointer" }}>
          <UserImage image={profile_image} size={50} />

          <ProfileName>
            {username && (
              <TextView
                variant="subtitle"
                style={{
                  color: colors.primary,
                  marginBottom: 0,
                  textTransform: "capitalize",
                  fontWeight: 700,
                }}
              >
                {username}
              </TextView>
            )}
            <TextView>
              {first_name} {last_name}
            </TextView>
          </ProfileName>
        </Profile>
        <Actions>
          {!isUserProfile && (
            <Button onClick={handleFollow} primary>
              <ButtonText>
                {followLoading && (
                  <CircularProgress
                    size={12}
                    sx={{ marginRight: "6px", color: "white" }}
                  />
                )}
                {isFollowing ? "Unfollow" : "Follow"}
              </ButtonText>
            </Button>
          )}
          {/* <Button onClick={onFollowOrMessage}>
            <ButtonText>Message</ButtonText>
          </Button> */}
        </Actions>
      </Header>
      {isMobileLandscape && <Button style={{ marginTop: 10 }}>Follow</Button>}
      <Stats>
        <Stat>
          <div>
            <StatText primary>{number_of_wheels ?? 0}</StatText>
            <br />
            <StatText>Wheels</StatText>
          </div>
        </Stat>
        <Divider />
        <Stat>
          <div>
            <StatText primary>{followerCount ?? followers ?? 0}</StatText>
            <br />
            <StatText>Followers</StatText>
          </div>
        </Stat>
        <Divider />
        <Stat>
          <div>
            <StatText primary>{followings ?? 0}</StatText>
            <br />
            <StatText>Following</StatText>
          </div>
        </Stat>
      </Stats>
    </Container>
  );
}

export default AuthorInfo;
